import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';
import HaventPermission from '../../assets/HaventPermission';
import MainMenuTab from './Tabs/MainMenu';
import ScreensaverTab from './Tabs/Screensaver';
import TvPanelTab from './Tabs/TvPanel';
import styles from './styles.module.scss';

const SIDE_TAB_KIOSK = 0;
const SIDE_TAB_TV = 1;

const InfoKiosk = ({ hasChanges, history }) => {
  const [sideTabIndex, setSideTabIndex] = useState(0);
  const [topTabIndex, setTopTabIndex] = useState(0);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const { readRight, updateRight } = usePermission('Настройка', 'Информационный терминал');

  useEffect(() => {
    const unblock = history.block((location) => {
      if (hasChanges) {
        setShowLeaveConfirm(true);
        setPendingNavigation(location.pathname);
        return false;
      }
      return true;
    });
    return () => unblock();
  }, [hasChanges, history]);

  const handleConfirmLeave = () => {
    setShowLeaveConfirm(false);
    if (pendingNavigation) {
      history.push(pendingNavigation);
    }
  };

  const handleCancelLeave = () => {
    setShowLeaveConfirm(false);
    setPendingNavigation(null);
  };

  if (!readRight) return <HaventPermission />;

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Настройка информационных экранов</p>
      <p className={styles.pageDesc}>
        В данном разделе выполняется настройка отображения информации на информационных киосках
        и ТВ-мультимедийных панелях расписания.
      </p>

      <div className={styles.layout}>
        {/* Side tabs */}
        <div className={styles.sideNav}>
          <button
            className={`${styles.sideNavBtn} ${sideTabIndex === SIDE_TAB_KIOSK ? styles.active : ''}`}
            onClick={() => setSideTabIndex(SIDE_TAB_KIOSK)}
          >
            Информационный терминал
          </button>
          <button
            className={`${styles.sideNavBtn} ${sideTabIndex === SIDE_TAB_TV ? styles.active : ''}`}
            onClick={() => setSideTabIndex(SIDE_TAB_TV)}
          >
            ТВ-панель
          </button>
        </div>

        {/* Content */}
        <div className={styles.content}>
          {sideTabIndex === SIDE_TAB_KIOSK && (
            <Tabs selectedIndex={topTabIndex} onSelect={setTopTabIndex}>
              <TabList>
                <Tab className="table-mark__years_item" selectedClassName="active-item">
                  Главное меню
                </Tab>
                <Tab className="table-mark__years_item" selectedClassName="active-item">
                  Заставка
                </Tab>
              </TabList>
              <TabPanel className={styles.tabContent}>
                <MainMenuTab updateRight={updateRight} />
              </TabPanel>
              <TabPanel className={styles.tabContent}>
                <ScreensaverTab updateRight={updateRight} />
              </TabPanel>
            </Tabs>
          )}

          {sideTabIndex === SIDE_TAB_TV && (
            <TvPanelTab updateRight={updateRight} />
          )}
        </div>
      </div>

      {showLeaveConfirm && (
        <div className={styles.confirmationOverlay}>
          <div className={styles.confirmationDialog}>
            <h3>Есть несохранённые изменения. Покинуть страницу?</h3>
            <div className={styles.confirmationButtons}>
              <button onClick={handleConfirmLeave}>Да</button>
              <button onClick={handleCancelLeave}>Нет</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ infoKiosk }) => ({
  hasChanges: infoKiosk.hasChanges
});

export default withRouter(connect(mapStateToProps)(InfoKiosk));
